export default "__VITE_ASSET__9d1ea94c__"